import React, { useCallback } from 'react';
import { Tab, useTabStore } from '../../store/tabs';
import { ChatInterface } from '../Chat/ChatInterface';
import { EmailDrawer } from '../Email/EmailDrawer';
import SettingsPage from '../../pages/SettingsPage';

interface TabContentProps {
  className?: string;
}

export const TabContent: React.FC<TabContentProps> = ({ className }) => {
  const { tabs, activeTabId, updateTabState } = useTabStore();
  
  const activeTab = tabs.find(tab => tab.id === activeTabId);
  
  if (!activeTab) {
    return (
      <div className={`tab-content-empty ${className || ''}`} style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        height: '100%',
        color: 'var(--color-text-secondary)',
        backgroundColor: 'var(--color-bg-primary)', // Match workspace background
      }}>
        <div style={{ textAlign: 'center' }}>
          <h3>No tab selected</h3>
          <p>Select a workspace from the left navigation to get started.</p>
        </div>
      </div>
    );
  }

  const renderTabContent = (tab: Tab) => {
    switch (tab.type) {
      case 'email':
        return (
          <div style={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
            <EmailDrawer
              isOpen={true}
              onClose={() => {}}
              isFullWidth={true}
            />
          </div>
        );
      
      case 'workspace':
        return (
          <div style={{ height: '100%', width: '100%', display: 'flex', flexDirection: 'column' }}>
            <ChatInterface 
              workspace={tab.workspace}
              initialState={tab.state}
              tabId={tab.id}
            />
          </div>
        );
      
      case 'settings':
        return (
          <div style={{ height: '100%', overflow: 'auto' }}>
            <SettingsPage />
          </div>
        );
      
      default:
        return (
          <div style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            height: '100%',
            color: 'var(--color-text-secondary)',
            backgroundColor: 'var(--color-bg-primary)', // Match workspace background
          }}>
            <p>Unknown tab type: {tab.type}</p>
          </div>
        );
    }
  };

  return (
    <div className={`tab-content ${className || ''}`} style={{
      height: '100%',
      width: '100%',
      overflow: 'hidden',
    }}>
      {renderTabContent(activeTab)}
    </div>
  );
};